import { create, useStore } from "zustand";
import axios from "../../services/api";
import { persist, createJSONStorage } from "zustand/middleware";
import { BASE_URL } from "../../services/globoplay-api";

const DEFAULT_DURATION = 60;

export interface Clip {
    uuid: string;
    address: string;
    source_name: string;
    datetime_from: string;
    duration: number;
    status: "processing" | "ready" | string;
    is_available: boolean;
    create_date: string | null;
    upadate_date: string | null;
}

interface ClipsState {
    clips?: Clip;
    uuid?: string;
    duration?: number;
    isLoadingNewMedia: boolean;
    loading: boolean;
    currentClipDuration: number;
    setCurrentClipDuration: (value: number) => void;
    currentClipDatetime: number;
    setCurrentClipDatetime: (value: number) => void;
    fetchClips: (params: {
        profile?: string;
        datetime: number;
        duration?: number;
    }) => Promise<Clip | null>;
    clearClips: () => void;
}

export const useClipsStore = create<ClipsState>()(
    persist(
        (set, get) => ({
            clips: undefined,
            uuid: undefined,
            duration: undefined,
            isLoadingNewMedia: false,
            currentClipDuration: 0,
            loading: false,
            setCurrentClipDuration: (value) => set({ currentClipDuration: value }),
            currentClipDatetime: 0,
            setCurrentClipDatetime: (value) => set({ currentClipDatetime: value }),
            fetchClips: async ({
                profile,
                datetime,
                duration = DEFAULT_DURATION,
            }) => {
                set({ clips: undefined });
                set({ loading: true, isLoadingNewMedia: true });
                // TODO para testes locais
                const clipsUrl =
                    `${BASE_URL}/clips?source_name=${profile ?? ""}` +
                    `&datetime_from=${datetime}&duration=${duration}`;
                /*const clipsUrl =
                    `http://localhost:8182/api/clips?source_name=${profile ?? ""}` +
                    `&datetime_from=${datetime}&duration=${duration}`;*/
                try {
                    const { data } = await axios.post<Clip>(clipsUrl);

                    set({
                        clips: data,
                        uuid: data.uuid,
                        duration: duration,
                    });
                    return data;
                } catch (err) {
                    console.error(err);
                    set({ clips: undefined });
                    return null;
                } finally {
                    set({ loading: false, isLoadingNewMedia: false });
                }
            },

            clearClips: () => set({ clips: undefined }),
        }),
        {
            name: "clips-storage",                         // chave no localStorage
            storage: createJSONStorage(() => localStorage),
            partialize: (s) => ({ clips: s.clips, uuid: s.uuid, duration: s.duration }),
            version: 1,
        },
    ),
);